import { styled, theme } from '@clickcease/cc-client-components-lib'

const {
  space: {
    '8': { value: space8 },
  },
} = theme

export const ValidationContainer = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
})

export const ValidationNoticeWrapper = styled('div', {
  display: 'flex',
  width: '200px',
  justifyContent: 'center',
  marginTop: '$5',
})
export const ValidationNotice = styled('div', {
  color: '$neutral',
  fontSize: '$md',
  fontWeight: '$l',
  margin: '0px 0px $3 $4',
})
export const ValidationNoticeTexts = styled('div', {
  display: 'flex',
  flexDirection: 'column',
})
export const ValidationMessageContainer = styled(ValidationNoticeWrapper, {
  '> :first-child': {
    height: space8,
    width: space8,
    marginRight: '$4',
  },

  variants: {
    success: {
      true: {
        color: '$success',
      },
      false: {
        color: '$error',
      },
      loading: {
        color: '$grey',
      },
    },
  },
})

export const ValidationIconCircle = styled('div', {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  minWidth: space8,
  minHeight: space8,
  borderRadius: '50%',
  border: '1px solid currentColor',
})

export const ValidationMessage = styled('span', {
  fontSize: '$md',
  fontWeight: '$l',
  overflow: 'hidden',
  wrap: 'normal',
  textOverflow: 'wrap',
  lineHeight: '18px',
})

export const ValidationFailWrapper = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  gap: '$8',
})

export const ValidationFailText = styled('span')

export const Link = styled('a', {
  all: 'unset',
  fontWeight: '$r',
  fontSize: '$md',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  color: '$primaryColor',
  userSelect: 'none',
  cursor: 'pointer',
  textDecoration: 'underline',
  '&:hover': {
    textDecoration: 'none',
  },
})
